import { gql, useQuery } from '@apollo/client'

import type { GQL_ID, ProductFilter } from '@@types'

export type ProductFiltersQuery = {
  productFilters: ProductFilter[]
}

export type ProductFiltersVariables = {
  shop_id: GQL_ID
  category_id?: GQL_ID
}

export const GQL_QUERY_PRODUCT_FILTERS = gql`
  query productFilters(
    $shop_id: ID!
    $category_id: ID
  ) {
    productFilters(
      shop_id: $shop_id
      category_id: $category_id
    ) {
      id
      label
      type
      filterInputFieldName
      op
      values {
        value
        name
      }
    }
  }
`

export const useProductFilters = (variables: ProductFiltersVariables) => {
  const result = useQuery<ProductFiltersQuery, ProductFiltersVariables>(GQL_QUERY_PRODUCT_FILTERS, {
    variables,
    skip: !variables.category_id,
    fetchPolicy: 'cache-and-network'
  })

  const filters = result.data?.productFilters ?? []

  return {
    filters,
    ...result
  }
}
